export const SocialLinks = {
    twitter: 'https://twitter.com/RealyOfficial',
    discord: 'https://t.co/e40zcAKPGH',
    telegram: 'https://t.me/realyofficial',
    instagram: 'https://www.instagram.com/realy.pro/',
    medium: 'https://medium.com/@realy'
}
